import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

/**
 * Compact centered stat card: optional icon, a large numeric value, and a label.
 * Shared by the home dashboard and the admin reporting page.
 */
export default function StatCard({ icon, value, label, loading, color }: {
    icon?:   React.ReactNode;
    value:   number;
    label:   string;
    loading: boolean;
    color?:  string;
}) {
    return (
        <Card>
            <CardContent sx={{ textAlign: 'center', py: 4 }}>
                {icon}
                {loading ? (
                    <Skeleton variant="text" width={60} sx={{ mx: 'auto', mt: 1 }} height={48} />
                ) : (
                    <Typography variant="h4" fontWeight={700} mt={1} sx={color ? { color } : undefined}>
                        {value.toLocaleString()}
                    </Typography>
                )}
                <Typography variant="body2" color="text.secondary">{label}</Typography>
            </CardContent>
        </Card>
    );
}
